import React from 'react';
import styles from '../../styles/shared/CardGrid.module.css';
import { SubLocation } from '../../types/location';

interface SubLocationCardProps {
  subLocation: SubLocation;
  onEdit: (subLocation: SubLocation) => void;
  onDelete?: (subLocationId: number) => void;
}

const SubLocationCard: React.FC<SubLocationCardProps> = ({ subLocation, onEdit, onDelete }) => {
  return (
    <div className={styles.card}>
      <div className={styles.imageContainer}>
        <div className={styles.placeholderImage}>
          <span>🗺️</span>
        </div>
      </div>

      <div className={styles.cardContent}>
        <h3 className={styles.cardTitle} title={subLocation.sub_location_name}>{subLocation.sub_location_name}</h3>
        {subLocation.long_lat && (
          <p className={styles.cardDescription} title={`Coordinates: ${subLocation.long_lat}`}>Coordinates: {subLocation.long_lat}</p>
        )}

        <div className={styles.cardActions}>
          <button
            onClick={() => onEdit(subLocation)}
            className={`${styles.cardActionButton} ${styles.cardEditButton}`}
            title="Edit SubLocation"
          >
            Edit
          </button>
          {onDelete && (
            <button
              onClick={() => onDelete(subLocation.id)}
              className={`${styles.cardActionButton} ${styles.cardDeleteButton}`}
              title="Delete SubLocation"
            >
              Delete
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubLocationCard;
